module.exports = __webpack_public_path__ + "static/Hook_Horror-c038f6e7f081f97ed12579d3d1090be3.jpg";